import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";

const LINKS = [
  { label: "The Fleet", href: "/#fleet", id: "fleet" },
  { label: "Services", href: "/#services", id: "services" },
  { label: "Packages", href: "/packages", id: "packages" },
  { label: "Experience", href: "/#experience", id: "experience" },
  { label: "Contact", href: "/#contact", id: "contact" },
];

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.6, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-40 transition-colors duration-500 ${scrolled ? "glass-lux" : "bg-transparent"}`}
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={`nav-link-${l.id}`}
              className="font-mono-lux text-[11px] uppercase tracking-[0.3em] text-zinc-400 hover:text-amber-400 transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/book"
            data-testid="nav-reserve-button"
            className="font-mono-lux text-[11px] uppercase tracking-[0.3em] px-6 py-3 border border-amber-500/40 text-amber-300 hover:bg-amber-500 hover:text-black transition-colors duration-300"
          >
            Reserve
          </Link>
        </nav>
        <button
          className="md:hidden text-amber-200"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden glass-lux border-t border-amber-500/10 px-6 py-6 flex flex-col gap-5" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={l.href}
              onClick={() => setOpen(false)}
              className="font-mono-lux text-xs uppercase tracking-[0.3em] text-zinc-300"
            >
              {l.label}
            </a>
          ))}
          <Link to="/book" className="font-mono-lux text-xs uppercase tracking-[0.3em] text-amber-400">
            Reserve a Journey
          </Link>
        </div>
      )}
    </motion.header>
  );
}
